<template>
    <div v-if="user.profile?.id" class="profile">
        <div class="avatar"
            ref="avatar"
        >
            <Img v-if="user?.profile?.profileImage?.resized"
                :preview="user?.profile?.profileImage?.resized"
                :original="user?.profile?.profileImage?.original"
                :alt="user?.profile?.lastName"
            />
        </div>

        <label class="title">{{ user?.profile?.firstName }}</label>
    </div>
</template>

<script setup>
    import { useI18n } from 'vue-i18n';
    // import stores from '@/stores';

    import Img from '🔗/components/ui/Img.vue';

    const user = stores.user();
    const { t } = useI18n();
</script>

<style lang="scss" scoped>
    div.profile {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 8px;
        padding: 12px 24px;
        border-bottom: solid 1px var(--white-10);

        & > div.avatar {
            width: 30px;
            height: 30px;
            border-radius: 50%;

            & > img {
                width: 100%;
                height: 100%;
                border-radius: 50%;
                z-index: 1;
                position: relative;
            }
        }


        .title {
            font: var(--font-body-2);
            font-weight: bold;
            color: var(--white-500);
            padding-top: 1px;
        }
    }
</style>
